import routes from './routes'

/**
 * Unique Line Awesome icons per known menu path.
 * Includes legacy /admin/* paths so ACL rows still resolve icons during migration.
 */
export const MENU_ICONS_BY_PATH = {
  [routes.dashboard]: 'las la-home',
  [routes.preferences]: 'las la-sliders-h',
  [routes.utm]: 'las la-chart-line',
  [routes.utmNew]: 'las la-plus-circle',
  [routes.pensionUsers]: 'las la-users',
  [routes.pensionCalculations]: 'las la-calculator',
  [routes.logs]: 'las la-file-alt',
  [routes.help]: 'las la-life-ring',
  [routes.support]: 'las la-headset',
  [routes.onboarding]: 'las la-rocket',
  // Legacy English / ACL bookmarks
  '/dashboard': 'las la-home',
  '/admin/dashboard': 'las la-home',
  '/preferences': 'las la-sliders-h',
  '/admin/preferences': 'las la-sliders-h',
  '/admin/utm': 'las la-chart-line',
  '/admin/utm/new': 'las la-plus-circle',
  '/admin/pension/usuarios': 'las la-users',
  '/pension/usuarios': 'las la-users',
  '/users': 'las la-users',
  '/pension/calculations': 'las la-calculator',
  '/admin/pension/calculations': 'las la-calculator',
  '/logs': 'las la-file-alt',
  '/admin/logs': 'las la-file-alt',
  '/support': 'las la-headset',
  '/admin/support': 'las la-headset',
  '/admin/ayuda': 'las la-life-ring',
}

const MENU_ICONS_BY_NAME = {
  dashboard: 'las la-home',
  inicio: 'las la-home',
  indicadores: 'las la-tachometer-alt',
  preferencias: 'las la-sliders-h',
  perfil: 'las la-user',
  utm: 'las la-chart-line',
  usuarios: 'las la-users',
  calculos: 'las la-calculator',
  pension: 'las la-hand-holding-usd',
  logs: 'las la-file-alt',
  bitacora: 'las la-clipboard-list',
  ayuda: 'las la-life-ring',
  contacto: 'las la-life-ring',
  soporte: 'las la-life-ring',
  tickets: 'las la-headset',
}

const FALLBACK_ICONS = [
  'las la-home',
  'las la-chart-bar',
  'las la-users',
  'las la-calculator',
  'las la-file-alt',
  'las la-cog',
  'las la-wallet',
  'las la-bell',
  'las la-calendar',
  'las la-layer-group',
  'las la-chart-pie',
  'las la-clipboard-list',
]

const normalizeName = (name = '') =>
  name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()

/**
 * Resolve a unique icon class for each visible menu item.
 */
export const resolveMenuIcons = (menus = []) => {
  const used = new Set()
  let fallbackIndex = 0

  const pickUnusedFallback = () => {
    while (fallbackIndex < FALLBACK_ICONS.length) {
      const next = FALLBACK_ICONS[fallbackIndex]
      fallbackIndex += 1
      if (!used.has(next)) return next
    }
    return 'las la-circle'
  }

  return menus.map((menu) => {
    const byPath = menu.path ? MENU_ICONS_BY_PATH[menu.path] : null
    const byName = MENU_ICONS_BY_NAME[normalizeName(menu.name)]
    let icon = byPath || byName || menu.styles || 'las la-circle'

    if (used.has(icon)) {
      icon = pickUnusedFallback()
    }

    used.add(icon)
    return { ...menu, icon }
  })
}
